import React from 'react';
import ExpandableContainer from '../ExpandableContainer';
import * as Row from '../../../layout/Row';

export default class SummaryHeatingSection extends React.Component {
    render() {
        const heatExchangerOutput = this.props.heatingModel.heatExchangerOutput || []
        const hasHeatExchangerOutput = heatExchangerOutput.length > 0

        return (
            <ExpandableContainer
                label={this.props.isDHW ? this.props.model.dhw.name.value : `${this.props.model['heating' + this.props.index].name.value}`}>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        {this.renderHeatExchanger()}
                        <div style={{width: '100%', height: '2.5rem'}}></div>
                        {hasHeatExchangerOutput && this.renderOutputData(heatExchangerOutput)}
                    </Row.Column6>
                    <Row.Column6 className="configuration-editor-summary-thumbnail">
                        <img src={this.props.heatingModel.heatExchangerThumbnail}/>
                    </Row.Column6>
                </Row.Container>
                {
                    this.isPumpAvailable() && (
                        <React.Fragment>
                            <Row.Container hasOuterGutter={false}>
                                <Row.Column6>
                                    <div style={{width: '100%', height: '2.5rem'}}></div>
                                    {this.renderPump()}
                                    <div style={{width: '100%', height: '2.5rem'}}></div>
                                    {this.renderPumpWorkingConditions()}
                                </Row.Column6>
                                <Row.Column6 className="configuration-editor-summary-thumbnail">
                                    <img src={this.props.heatingModel.pumpModelThumbnail}/>
                                </Row.Column6>
                            </Row.Container>
                        </React.Fragment>
                    )}

                {this.isSecondarySideComponentsAvailable() && (
                    <React.Fragment>
                        <Row.Container hasOuterGutter={false}>
                            <Row.Column8>
                                <div style={{width: '100%', height: '2.5rem'}}></div>
                                {this.renderSecondarySideComponents()}
                            </Row.Column8>
                            <Row.Column4></Row.Column4>
                        </Row.Container>
                    </React.Fragment>
                )}
            </ExpandableContainer>
        )
    }

    renderHeatExchanger() {
        if (this.props.heatingModel.heatExchangerName.value == null)
            return <React.Fragment></React.Fragment>
        return (
            <div className="configuration-editor-summary-ut-section heating-section">
                <div>{__('Heat exchanger')}</div>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        <div className="configuration-editor-summary-heating-field">
                            <div>{__('Model')}</div>
                            <div>{this.props.heatingModel.heatExchangerName.value}</div>
                        </div>
                    </Row.Column6>
                    {this.renderNumberOfPlates()}

                </Row.Container>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6>
                        <div className="configuration-editor-summary-heating-field" style={{marginTop: ".75rem"}}>
                            <div>{__('Capacity')}</div>
                            <div>{this.props.heatingModel.capacity.value} {this.props.heatingModel.capacity.unit}</div>
                        </div>
                    </Row.Column6>
                    <Row.Column6>
                    </Row.Column6>
                </Row.Container>
            </div>
        )
    }

    renderNumberOfPlates = () => {
        let numberOfPlates = this.props.heatingModel.heatExchangerNumberOfPlates
        if (typeof numberOfPlates === 'undefined' || numberOfPlates === null) {
            return <React.Fragment></React.Fragment>
        }
        return (<Row.Column6>
            <div className="configuration-editor-summary-heating-field">
                <div>{__('Number of plates')}</div>
                <div>{this.props.heatingModel.heatExchangerNumberOfPlates}</div>
            </div>
        </Row.Column6>)
    }

    renderOutputData(output) {
        const renderRows = () => {
            let result = []

            for (let row of output) {
                result.push(
                    <tr key={output.indexOf(row)}>
                        <td>{row.name}</td>
                        <td>{row.primary}</td>
                        <td>{row.secondary}</td>
                        <td>{row.unit}</td>
                    </tr>
                )
            }

            return result
        }

        return (
            <div className="configuration-editor-summary-ut-section">
                <div>{__('Heating output')}</div>
                <div className="configuration-editor-summary-table-wrapper">
                    <table className="configuration-editor-summary-table-multi">
                        <thead>
                        <tr>
                            <th></th>
                            <th>{__('Primary')}</th>
                            <th>{__('Secondary')}</th>
                            <th>{__('Unit')}</th>
                        </tr>
                        </thead>

                        <tbody>
                        {renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderPump() {
        const heatingModel = this.props.heatingModel

        return (
            <div className="configuration-editor-summary-ut-section heating-section">
                <div>{__('Pump')}</div>
                <div>
                    <Row.Container hasOuterGutter={false}>
                        {this.isFieldAvailable(heatingModel.pumpManufacturer) && (
                            <Row.Column6>
                                <div className="configuration-editor-summary-heating-field">
                                    <div>{__('Manufacturer')}</div>
                                    <div>{this.getFieldValue(heatingModel.pumpManufacturer)}</div>
                                </div>
                            </Row.Column6>
                        )}

                        {this.isFieldAvailable(heatingModel.pump) && (
                            <Row.Column6>
                                <div className="configuration-editor-summary-heating-field">
                                    <div>{__('Model')}</div>
                                    <div>{this.getFieldValue(heatingModel.pump)}</div>
                                </div>
                            </Row.Column6>
                        )}
                    </Row.Container>
                </div>
            </div>
        )
    }

    renderPumpWorkingConditions() {
        const heatingModel = this.props.heatingModel
        const renderRows = () => {
            let results = []

            if (this.isFieldAvailable(heatingModel.requiredLiftingHeight)) {
                results.push({
                    label: __('Lifting height'),
                    value: heatingModel.requiredLiftingHeight.value + ' ' + heatingModel.requiredLiftingHeight.unit
                })
            }

            if (this.isFieldAvailable(heatingModel.pumpLiftingHeight)) {
                results.push({
                    label: __('Max lifting height'),
                    value: heatingModel.pumpLiftingHeight.value + ' ' + heatingModel.pumpLiftingHeight.unit
                })
            }

            if (this.isFieldAvailable(heatingModel.pumpVoltage)) {
                results.push({
                    label: heatingModel.pumpVoltage.label,
                    value: heatingModel.pumpVoltage.value + ' ' + heatingModel.pumpVoltage.unit
                })
            }

            if (this.isFieldAvailable(heatingModel.maxPower)) {
                results.push({
                    label: heatingModel.maxPower.label,
                    value: heatingModel.maxPower.value + ' ' + heatingModel.maxPower.unit
                })
            }

            if (this.isFieldAvailable(heatingModel.maxCurrent)) {
                results.push({
                    label: heatingModel.maxCurrent.label,
                    value: heatingModel.maxCurrent.value + ' ' + heatingModel.maxCurrent.unit
                })
            }

            if (this.isFieldAvailable(heatingModel.pumpFlow)) {
                results.push({
                    label: heatingModel.pumpFlow.label,
                    value: heatingModel.pumpFlow.value + ' ' + heatingModel.pumpFlow.unit
                })
            }

            if (this.isFieldAvailable(heatingModel.pumpAddOn)) {
                results.push({
                    label: heatingModel.pumpAddOn.label,
                    value: this.getFieldValue(heatingModel.pumpAddOn)
                })
            }

            results = results.map((r, idx) => (
                <tr key={idx}>
                    <td>{r.label}</td>
                    <td>{this.getFieldValue(r)}</td>
                </tr>
            ))

            return results
        }

        return (
            <div className="configuration-editor-summary-ut-section">
                <div>{__('Pump working conditions')}</div>
                <div className="configuration-editor-summary-table-wrapper">
                    <table className="configuration-editor-summary-table">
                        <tbody>
                        {renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderSecondarySideComponents() {
        const heatingModel = this.props.heatingModel

        const leftRowsResults = () => {
            let results = []

            if (this.isFieldAvailable(heatingModel.secondaryPipeSize)) {
                results.push({
                    label: heatingModel.secondaryPipeSize.label + " / " + __('Connection type'),
                    value: ("DN" + this.getFieldValue(heatingModel.secondaryPipeDN) + " / " + this.getFieldValue(heatingModel.secondaryPipeSize))
                })
            }

            if (this.isFieldAvailable(heatingModel.circulationValve)) {
                results.push({
                    label: heatingModel.circulationValve.label,
                    value: this.getFieldValue(heatingModel.circulationValve)
                })
            }

            if (this.isFieldAvailable(heatingModel.coldWaterMeter)) {
                results.push({
                    label: heatingModel.coldWaterMeter.label,
                    value: this.getFieldValue(heatingModel.coldWaterMeter)
                })
            }

            if (this.isFieldAvailable(heatingModel.valveSupply)) {
                results.push({
                    label: heatingModel.valveSupply.label,
                    value: this.getFieldValue(heatingModel.valveSupply)
                })
            }

            if (this.isFieldAvailable(heatingModel.filling)) {
                results.push({
                    label: heatingModel.filling.label,
                    value: this.getFieldValue(heatingModel.filling)
                })
            }

            if (this.isFieldAvailable(heatingModel.deaerator)) {
                results.push({
                    label: heatingModel.deaerator.label,
                    value: this.getFieldValue(heatingModel.deaerator)
                })
            }

            if (this.isFieldAvailable(heatingModel.vacuumDGSR)) {
                results.push({
                    label: heatingModel.vacuumDGSR.label,
                    value: this.getFieldValue(heatingModel.vacuumDGSR)
                })
            }

            return results
        }

        const rightRowsResults = () => {
            let results = []

            if (this.isFieldAvailable(heatingModel.circulationPipeDN)) {
                results.push({
                    label: __('Circulation pipe size') + " / " + __('Connection type'),
                    value: ("DN" + this.getFieldValue(heatingModel.circulationPipeDN) + " / " + this.getFieldValue(heatingModel.circulationPipeSize))
                })
            }

            if (this.isFieldAvailable(heatingModel.safetyValve)) {
                results.push({
                    label: heatingModel.safetyValve.label,
                    value: this.getFieldValue(heatingModel.safetyValve)
                })
            }

            if (this.isFieldAvailable(heatingModel.coldWaterStrainer)) {
                results.push({
                    label: heatingModel.coldWaterStrainer.label,
                    value: this.getFieldValue(heatingModel.coldWaterStrainer)
                })
            }

            if (this.isFieldAvailable(heatingModel.dhWcStrainer)) {
                results.push({
                    label: heatingModel.dhWcStrainer.label,
                    value: this.getFieldValue(heatingModel.dhWcStrainer)
                })
            }

            if (this.isFieldAvailable(heatingModel.strainerOption)) {
                results.push({
                    label: heatingModel.strainerOption.label,
                    value: this.getFieldValue(heatingModel.strainerOption)
                })
            }

            if (this.isFieldAvailable(heatingModel.manometer)) {
                results.push({
                    label: heatingModel.manometer.label,
                    value: this.getFieldValue(heatingModel.manometer)
                })
            }

            if (this.isFieldAvailable(heatingModel.serviceBypass)) {
                results.push({
                    label: heatingModel.serviceBypass.label,
                    value: this.getFieldValue(heatingModel.serviceBypass)
                })
            }

            if (this.isFieldAvailable(heatingModel.ThermostaticSafetyMixingValve)) {
                results.push({
                    label: heatingModel.ThermostaticSafetyMixingValve.label,
                    value: this.getFieldValue(heatingModel.ThermostaticSafetyMixingValve)
                })
            }

            return results
        }

        const renderLeftRows = () => {
            let results = leftRowsResults()
            if (results.length) {
                return (
                    <div className="column-6 column-xs-12">
                        <div className="configuration-editor-summary-table-wrapper">
                            <table className="configuration-editor-summary-table">
                                <tbody>
                                {transformResults(results)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }
            return <React.Fragment></React.Fragment>
        }

        const renderRightRows = () => {
            let results = rightRowsResults()
            if (results.length) {
                return (
                    <div className="column-6 column-xs-12">
                        <div className="configuration-editor-summary-table-wrapper">
                            <table className="configuration-editor-summary-table">
                                <tbody>
                                {transformResults(results)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }
            return <React.Fragment></React.Fragment>
        }

        const transformResults = results => {
            return results.map((r, idx) => (
                <tr key={idx}>
                    <td>{r.label}</td>
                    <td>{this.getFieldValue(r)}</td>
                </tr>
            ))
        }

        return (
            <div className="configuration-editor-summary-ut-section heating-section">
                <div>{__('Secondary side components')}</div>
                <div>
                    <Row.Container hasOuterGutter={false}>
                        {renderLeftRows()}
                        {renderRightRows()}
                    </Row.Container>
                </div>
            </div>
        )
    }

    isPumpAvailable() {
        const heatingModel = this.props.heatingModel

        return (
            this.isFieldAvailable(heatingModel.pumpManufacturer) &&
            this.isFieldAvailable(heatingModel.pump)
        )
    }

    isSecondarySideComponentsAvailable() {
        const heatingModel = this.props.heatingModel

        return (
            this.isFieldAvailable(heatingModel.filling) ||
            this.isFieldAvailable(heatingModel.pressureMetering) ||
            this.isFieldAvailable(heatingModel.safetyValve) ||
            this.isFieldAvailable(heatingModel.primaryPipeSize) ||
            this.isFieldAvailable(heatingModel.deaerator)
        )
    }

    isFieldAvailable = x => (typeof x !== 'undefined' && x.value && x.visible)

    getFieldValue(field) {
        if (field.items) {
            let val = field.items.find(x => x.value === field.value)
            if (typeof val === 'object') {
                return val.text
            }
        }

        return field.value
    }
}
